/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalinformation1Inputs */

const en_personalinformation1 = /** @type {(inputs: Personalinformation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal Information`)
};

const de_personalinformation1 = /** @type {(inputs: Personalinformation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Persönliche Daten`)
};

/**
* | output |
* | --- |
* | "Personal Information" |
*
* @param {Personalinformation1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const personalinformation1 = /** @type {((inputs?: Personalinformation1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalinformation1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_personalinformation1(inputs)
	return de_personalinformation1(inputs)
});
export { personalinformation1 as "personalInformation" }